<template>
  <div>
    <div class="modal modal--welcomeback modal--zero-balance "
         id="welcome_modal">
      <div class="modal__content">
        <button class="btn modal-close">
          <i class="icon-close"></i>
        </button>
        <div class="modal__header modal_ti_header">
        </div>
        <div class="modal__body">
          <h1>{{ getTranslations.home_modals_confirm_purchase_purchase }}</h1>
          <img class="modal_icon_alert"
               src="static/images/modals/confirm_purchase.png">
          <p class="modal_strong">
            {{ getBundleData.numberOfCoins}} {{ getTranslations.home_modals_confirm_purchase_pin_games }} – {{ getBundleData.price}} {{ getBundleData.currencyCode }}
          </p>
          <p>{{ getTranslations.home_modals_confirm_purchase_pin_we_have_sent }}</p>
          <form action="">
            <div :class="['form-group', errorMessage ? 'has-warning' : '' ]">
              <input type="text"
                     @keyup="check()"
                     class="form-group__textfield phone_input"
                     v-model="pin"
                     :placeholder="getTranslations.home_modals_confirm_purchase_pin_enter_the_4"/>
              <span v-show="errorMessage"
                    class="form-group__feedback">
                {{ message }}
              </span>
            </div>
            <input type="submit"
                   :value="getTranslations.home_modals_confirm_purchase_pin_confirm_button"
                   @click.prevent="purchaseBundle()"
                   :class="['ti_btn--main', (errorMessage || !buttonEnabled)? 'deactivated' : '']">
          </form>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
import ConfirmPurchaseSuccessful from './ConfirmPurchaseSuccessful';
import ConfirmPurchaseForPinError from './ConfirmPurchaseForPinError';
import FailedPurchase from './FailedPurchase';

export default {
  name: 'confirm-purchase-for-pin',
  data() {
    return {
      errorMessage: false,
      message: '',
      pin: '',
      showedModal: false,
      buttonEnabled: true,
    };
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForStore',
    ]),
    ...mapActions('profile', [
      'getUserLoginDetails',
      'chargePinCall',
    ]),
    check() {
      const validPinRegex = /^[0-9]{0,8}$/;
      const validPin = this.pin.match(validPinRegex);
      if (!validPin) {
        this.message = this.getTranslations.home_modals_confirm_purchase_pin_oops;
        this.errorMessage = true;
      } else {
        this.errorMessage = false;
        this.message = '';
      }
    },
    showModal() {
      /* eslint-disable */
      this.$nextTick(() => {
        // vm for instance of vue, and in it, the this is for window so the next line is necessary
        // open modal
        $('.modal,.modal-overlay').fadeIn(200);
        // show/hide modal
        $('.modal-close, .modal-overlay').click(() => {
          $('.modal, .modal-overlay').fadeOut();
          if (!this.showedModal) {
            this.showedModal = true;
            this.storeModalForStore(null);
          } else {
            this.storeModalForStore(null);
          }
        });
      });
      /* eslint-enable */
    },
    purchaseBundle() {
      if (!this.errorMessage && (this.pin.length >= 4 && this.pin.length <= 8)) {
        this.buttonEnabled = false;
        this.getUserLoginDetails().then(() => {
          const bundleInfo = {
            bundleId: this.bundleId,
            pin: this.pin,
          };
          this.chargePinCall({ value: bundleInfo }).then(() => {
            this.buttonEnabled = true;
            if (this.chargePinResponse === 'OPERATION_SUCCESS') {
              this.storeModalForStore(ConfirmPurchaseSuccessful);
              this.$emit('bundlePurchase');
            } else if (this.chargePinResponse === 'WRONG_PIN') {
              this.errorMessage = true;
              this.message = this.getTranslations.home_modals_confirm_purchase_pin_oops;
            } else if (this.chargePinResponse === 'NO_BALANCE') {
              this.storeModalForStore(FailedPurchase);
              this.errorMessage = true;
              this.message = this.getTranslations.home_modals_confirm_purchase_pin_no_balance;
            } else {
              this.storeModalForStore(ConfirmPurchaseForPinError);
            }
            this.showModal();
          });
        });
      } else {
        this.message = this.getTranslations.home_modals_confirm_purchase_pin_oops;
        this.errorMessage = true;
      }
    },
  },
  computed: {
    ...mapState('profile', [
      'chargePinResponse',
      'bundleId',
    ]),
    ...mapGetters('profile', [
      'getBundleData',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/ConfirmPurchaseForPin.vue